import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Dashboard from "./pages/dashboard";
import RecordsByDate from "./pages/recordsByDate";
import {DateProvider} from "./contexts/DateContext";

function App() {

    return (
        <DateProvider>
            <Router>
                <div className="App">
                    <Routes>
                        <Route path="/" element={<Dashboard/>}/>
                        <Route path="/logs" element={<RecordsByDate/>}/>
                    </Routes>
                </div>
            </Router>
        </DateProvider>
    );
}

export default App;
